import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../../api/apiClient';
import { Button, Form, Container, Row, Col, Pagination, Badge } from 'react-bootstrap';
import { MediaPlayer, PopupModel, VideoCard, Input } from '../../shared';
import { getTags, levelConfig,setSession,getSession } from '../../../utils/utils';
import RefrenceList from './RefrenceList';
import { PlusIcon } from '../../../utils/FontIcon';
import { publish, subscribe, unsubscribe } from '../../../utils/pubsubWrapper';
import {VIDEOS,ADDREFERENCEDOC} from '../../../utils/ApiEndPoint';

const CourseVideoList = ({ reset, level }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [videos, setVideos] = useState([]);
    const [selectedVideoList, setSelectedVideoList] = useState([]);
    const [refrences, setRefrences] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedVideoId, setSelectedVideoId] = useState('');
    const [popupData, setPopupData] = useState({
        show: false,
        title: '',
        type: '',
        selectedItem: {},
    })
    const [searchBy, setSearchBy] = useState('');
    const [selectedLvel, setSelectedLevel] = useState(level || '');

    const pageSize = 10;
    useEffect(() => {
        reset && setSelectedVideoList([]);
    }, [reset])

    useEffect(() => {
        fetchVideos();
    }, []);
    useEffect(() => {
        const pubsubToken = subscribe('SELECTED_VIDEO', (video) => {
            setSelectedVideoList(video);
        });
        return () => unsubscribe(pubsubToken);
    }, []);
    useEffect(() => {
        const addItem = subscribe('ADD_ITEM_TO_VIDEO', (item) => {
            setRefrences((prev) => [...prev, item]);
        });
        return () => unsubscribe(addItem);
    }, []);
    useEffect(() => {
        const removeItem = subscribe('REMOVE_ITEM_FROM_VIDEO', (item) => {
            setRefrences((prev) => prev.filter((lesson) => lesson.refId !== item._id));
        });
        return () => unsubscribe(removeItem);
    }, []);
    const fetchVideos = async () => {
        setLoading(true)
        apiClient.get(VIDEOS)
            .then((response) => {
                if (response.status === 200) {
                    setVideos(response.data);
                } else {
                    setVideos([]);
                    setError('Failed to load videos');
                }
            }).catch((error) => {
                setVideos([]);
                setError('Failed to load videos');
            }).finally(() => {
                setLoading(false);
            });
    };

    const handleOpenModal = (video) => {
        setPopupData({
            show: true,
            title: video.title,
            type: 'video',
            selectedItem: video,
        });
    };

    const handleHideModal = () => {
        setSelectedVideoId('');
        setPopupData({
            show: false,
            title: '',
            type: '',
            selectedItem: {},
        });
    };
    const filteredByLevel = selectedLvel ? videos.filter(video => {
        const skilLevel = video.skillLevel || 'beginner';
        return skilLevel.toLowerCase() === selectedLvel.toLowerCase();
    }) : videos;
    const filteredVideos = filteredByLevel.filter(video => {
        const searchLower = search?.toLowerCase();
        if (searchBy === 'category' && video.topic) {
            return video?.topic?.toLowerCase().includes(searchLower)
        }
        else if (searchBy === 'keyword') {
            return video?.title?.toLowerCase().includes(searchLower) ||
                (Array.isArray(video.tags) ? video.tags.join(' ')?.toLowerCase() : '').includes(searchLower)
        } else if (searchBy === 'level') {
            return video?.skillLevel?.toLowerCase().includes(searchLower);
        }
        return true;

    });

    const paginatedVideos = filteredVideos.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const totalPages = Math.ceil(filteredVideos.length / pageSize);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handelAddVideos = (e) => {
        navigate('/addmanagevideo');
    }
    const handleSave = (selectedDocumentList) => {
        // if (selectedDocumentList && selectedDocumentList.length) {
            const data = {
                "documentIds": selectedDocumentList.map(ref => ref._id),
            }
            apiClient.put(`${VIDEOS}/${selectedVideoId}${ADDREFERENCEDOC}`, data)
                .then((response) => {
                    if (response.status === 200) {
                        fetchVideos();
                        setRefrences([]);
                    } else {
                        setError('Failed to load videos');
                    }
                }).catch((error) => {
                    setError('Failed to load videos');
                }).finally(() => {
                    handleHideModal();
                });
        // }
    }
    const handleCloseModal = () => {
        setRefrences([])
        handleHideModal();
    };

    const getRefrence = (video, idx) => {
        const hasRefRenceDoc = video?.referenceDocuments?.length
        return <Button variant='outline-secondary' className='add-reference-btn' size="sm" onClick={() => {
            setRefrences(video?.referenceDocuments || []);
            setPopupData({
                show: true,
                title: video.title,
                type: 'refrence',
                selectedItem: video?.referenceDocuments || [],
            });
            setSelectedVideoId(video._id);
        }}>
            {hasRefRenceDoc ? <>Manage Reference <Badge bg="secondary">{hasRefRenceDoc}</Badge></> : 'Attach Reference'}
        </Button>
    }
    const handelSelected = (video) => {
        const isSelected = selectedVideoList.some(v => (v._id === video._id || v.refId === video._id));
        if (isSelected) {
            setSelectedVideoList(prev => prev.filter(v => (v._id !== video._id && v.refId !== video._id)));
            publish('REMOVE_ITEM', video);
        } else {
            setSelectedVideoList(prev => [...prev, video]);
            publish('ADD_ITEM', {
                "type": "video",
                "refId": video._id,
                "titleOverride": video.title
            });
        }
    }
    const onHandelChange = (e) => {
        const { name, value } = e.target;
        if (name === 'searchBy') {
            setSearchBy(value);
            setSearch('');
            setSelectedLevel('');
        } else if (name === 'level') {
            setSelectedLevel(value);
            const courseLevels = getSession('levelForm');
            setSession('levelForm', {
                ...courseLevels,
                'videoLevel': value
            });

        }
    }
    if (loading) return <p>Loading videos...</p>;
    return (
        <Container fluid className='p0'>
            <Row className="justify-content-between align-items-center mb-1">
                <Col xs={6} md={6}>
                    <h6 className='m0'>Video Library <Badge className='list-selected-badge' style={{display:'table-caption'}}>{selectedVideoList.length} Selected</Badge></h6>
                </Col>
                <Col xs={6} md={6}>
                    <Button variant="outline-dark" className='addbtn-small fright' onClick={handelAddVideos} title='+ Add Videos'><PlusIcon style={{ fontSize: '10px' }} /> Add Videos</Button>
                </Col>
            </Row>
            {error ?
                <Container className='video-listing-bg'><p className='text-center'>{error}</p></Container>
                :
                <Container className='video-listing-bg'>
                    <Row>
                        <Col lg={12} xs={12} >
                            <Input
                                label="Difficulty Level"
                                type="select"
                                name="level"
                                value={selectedLvel}
                                onChange={onHandelChange}
                                options={levelConfig}
                            />
                        </Col>
                        <Col lg={4} xs={12} className='pright0'>
                            <Form.Select
                                aria-label="Default select example"
                                className='categary-select'
                                value={searchBy}
                                onChange={onHandelChange}
                                name="searchBy" >
                                <option value="">Search by</option>
                                <option value="category">Category</option>
                                <option value="keyword">Keyword</option>
                            </Form.Select>
                        </Col>
                        <Col lg={8} xs={12} className='ps-0 search-videosbar' style={{ position: 'relative' }}>
                            <Form.Control
                                placeholder="Search videos..."
                                type='search'
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                className='searchbox-input'
                                style={{ borderLeft: 'none', borderRadius: '0.375rem', borderTopLeftRadius: '0', borderBottomLeftRadius: '0' }}
                            />
                            <span className='search-icon' style={{ top: '-14px', position: 'absolute', right: '-5px' }}></span>
                        </Col>
                    </Row>
                    <Row className='listed-videos' style={{}}>
                        <Col lg={12}>
                            {paginatedVideos.map((video, idx) => {
                                return <VideoCard video={video} idx={idx} key={`video_${idx}`}
                                    checked={selectedVideoList.some(v => (v._id === video._id || v.refId === video._id))}
                                    handelSelected={handelSelected}
                                    handleOpenModal={handleOpenModal}
                                    getRefrence={getRefrence}
                                />
                            })}
                        </Col>
                    </Row>
                    <Row>
                        <div className="d-flex justify-content-end course-videolist-pagination">
                            <Pagination className='mypagination-listing'>
                                <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                                {[...Array(totalPages)].map((_, idx) => (
                                    <Pagination.Item
                                        key={idx + 1}
                                        active={currentPage === idx + 1}
                                        onClick={() => handlePageChange(idx + 1)}
                                    >
                                        {idx + 1}
                                    </Pagination.Item>
                                ))}
                                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                                <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                            </Pagination>
                        </div>
                    </Row>
                </Container>
            }
            {popupData?.show && popupData?.type === 'video' ?
                <PopupModel
                    size='lg'
                    showModal={popupData.show}
                    handleCloseModal={handleHideModal}
                    title={popupData.title}
                    type={popupData.type}
                >
                    {popupData?.selectedItem && (
                        <>
                            <Row>
                                <Col lg={12}>
                                    <MediaPlayer vidUrl={popupData?.selectedItem?._id} width={'100%'} height={'460'} />
                                </Col>

                            </Row>
                            <Row style={{
                                border: '1px solid #dbdbdb',
                                lineHeight: '2.4rem',
                                width: '100%',
                                margin: '0 auto'
                            }}>
                                <Col lg={2}><strong>Description:</strong></Col>
                                <Col lg={10}>{popupData?.selectedItem?.description}</Col>
                                <hr style={{ margin: '2px' }} />
                                <Col lg={2}><strong>Tags:</strong></Col>
                                <Col lg={10}>{getTags(popupData?.selectedItem?.tags)}</Col>
                            </Row>
                        </>
                    )}
                </PopupModel> : null
            }

            {popupData.show && popupData.type === 'refrence' ?
                <PopupModel
                    size='lg'
                    showModal={popupData.show}
                    handleCloseModal={handleCloseModal}
                    title={popupData.title}
                    type={popupData.type}
                >
                    <RefrenceList selectedItem={popupData.selectedItem} requestFrom={'video'} handelSave={handleSave} />
                </PopupModel> : null
            }
        </Container>
    );
};

export default CourseVideoList;